import React from 'react';
import { Link } from 'react-router-dom';
import { inr } from './ProfitWaterfall';
import { useTenantPath } from '../../lib/tenantPath';

// Won orders, weakest contribution first (losses on top).
export default function ProfitOrdersTable({ orders }) {
  const tenantPath = useTenantPath();
  if (!orders.length) return <p className="text-sm text-[#6D8E87] p-6" data-testid="profit-orders-empty">No won orders in this period.</p>;
  return (
    <div className="overflow-x-auto" data-testid="profit-orders-table">
      <table className="w-full text-sm">
        <thead className="text-xs text-[#6D8E87] uppercase tracking-wide">
          <tr className="border-b border-[#D5E8E4]">
            {['Customer', 'Owner', 'Month'].map((h) => <th key={h} className="text-left py-2 px-3">{h}</th>)}
            {['Revenue', 'COGS', 'Freight', 'Install & warranty', 'Commission', 'Contribution'].map((h) => <th key={h} className="text-right py-2 px-3">{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {orders.map((o, i) => (
            <tr key={o.quotation_id} className={`border-b border-[#EEF5F3] hover:bg-[#F4F9F7] transition-colors ${o.contribution < 0 ? 'bg-rose-50/50' : ''}`} data-testid={`profit-order-row-${i}`}>
              <td className="py-2 px-3"><Link to={tenantPath(`/leads/${o.lead_id}`)} className="text-[#00a69c] hover:underline">{o.customer || '—'}</Link>
                {o.quote_number && <span className="block text-[11px] text-[#6D8E87]">{o.quote_number}</span>}</td>
              <td className="py-2 px-3">{o.owner}</td>
              <td className="py-2 px-3">{o.month}</td>
              <td className="py-2 px-3 text-right tabular-nums">{inr(o.revenue + o.transport)}</td>
              <td className="py-2 px-3 text-right tabular-nums">{inr(-o.cogs)}</td>
              <td className="py-2 px-3 text-right tabular-nums">{inr(-o.freight)}{o.freight_estimated && <span className="block text-[10px] text-amber-700">estimated</span>}</td>
              <td className="py-2 px-3 text-right tabular-nums">{inr(-o.installation)}</td>
              <td className="py-2 px-3 text-right tabular-nums">{inr(-o.commission)}</td>
              <td className={`py-2 px-3 text-right tabular-nums font-semibold ${o.contribution < 0 ? 'text-rose-700' : 'text-[#00857e]'}`}>{inr(o.contribution)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
